import React from "react";
import { userHasClientRole } from "../user/UserCommon";
import BookingsFutureTabTable from "./BookingsFutureTabTable";
import BookingsPastTabTable from "./BookingPastTabTable";
import BookingDeclineExpiredTabTable from "./BookingDeclineExpiredTabTable";

export const BookingListTable = (props) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const { rows, selectedRow } = props;

    React.useEffect(() => {
        if (page * rowsPerPage >= rows.length) {
            setPage(0);
        }
    }, [rows.length]);

    const showRatingStars = () => {
        if (userHasClientRole() && props.hideRatingsFromClients) {
            return false;
        }
        return true;
    };

    const checkingPhoneNumber = (row) => {
        let phoneNumber;
        if (
            !row.clientMobilePhone.includes("N/A") &&
            row.clientMobilePhone.length >= 4
        ) {
            phoneNumber = row.clientMobilePhone;
        } else {
            if (
                !row.clientWorkPhone.includes("N/A") &&
                row.clientWorkPhone.length >= 4
            ) {
                phoneNumber = row.clientWorkPhone;
            } else {
                if (
                    !row.clientHomePhone.includes("N/A") &&
                    row.clientHomePhone.length >= 4
                ) {
                    phoneNumber = row.clientHomePhone;
                } else {
                    phoneNumber = "";
                }
            }
        }
        return phoneNumber;
    };
    return (
        <>
            {/* Bookings Declined/Expired Tab Table */}
            <div style={{ overflow: "auto" }}>
                {/* Future Tab Table */}
                {props.tab === "nonpending" && (
                    <>
                        {
                            <BookingDeclineExpiredTabTable
                                role={props.role}
                                rows={rows}
                                handleLoadMore={props.handleLoadMore}
                                endOfList={props.endOfList}
                                handleReqDetails={props.handleReqDetails}
                                showClientDialog={props.showClientDialog}
                            />
                        }
                    </>
                )}
            </div>

            {/* Bookings Past Tab Table */}
            <div style={{ overflow: "auto" }}>
                {/* Past Tab Table */}
                {props.tab === "past" && (
                    <>
                        {/* <h4>Past Tab Table</h4> */}
                        <BookingsPastTabTable
                            role={props.role}
                            rows={rows}
                            checkingPhoneNumber={checkingPhoneNumber}
                            showRatingStars={showRatingStars}
                            handleLoadMore={props.handleLoadMore}
                            endOfList={props.endOfList}
                            handleArrived={props.handleArrived}
                            handleAddCharge={props.handleAddCharge}
                            handleCompleted={props.handleCompleted}
                            handleNoShow={props.handleNoShow}
                            handleOverride={props.handleOverride}
                            refreshTable={props.refreshTable}
                            showClientDialog={props.showClientDialog}
                            showNoteDialog={props.showNoteDialog}
                            handleUpdateLocalBooking={
                                props.handleUpdateLocalBooking
                            }
                            onSaveNotes={props.onSaveNotes}
                        />
                    </>
                )}
            </div>

            {/* Bookings Future Tab Table */}
            <div style={{ overflow: "auto" }}>
                {/* Future Tab Table */}
                {props.tab === "future" && (
                    <>
                        {/* <h4>Future Tab Table</h4> */}
                        <BookingsFutureTabTable
                            role={props.role}
                            rows={rows}
                            checkingPhoneNumber={checkingPhoneNumber}
                            showRatingStars={showRatingStars}
                            handleLoadMore={props.handleLoadMore}
                            endOfList={props.endOfList}
                            handleArrived={props.handleArrived}
                            handleAddCharge={props.handleAddCharge}
                            handleCompleted={props.handleCompleted}
                            handleCancel={props.handleCancel}
                            handleOverride={props.handleOverride}
                            refreshTable={props.refreshTable}
                            showClientDialog={props.showClientDialog}
                            showNoteDialog={props.showNoteDialog}
                            handleUpdateLocalBooking={
                                props.handleUpdateLocalBooking
                            }
                            onSaveNotes={props.onSaveNotes}
                        />
                    </>
                )}
            </div>
        </>
    );
};
